import { useTheme } from "@mui/material";
import Typography from "components/basic/typography";

interface QuoteSectionProps {
  /** Left-aligned title shown in the black header bar. */
  title: string;
  /** Optional right-aligned label in the header bar (e.g. "AMOUNT"). */
  rightTitle?: string;
  children: React.ReactNode;
  maxWidth?: React.CSSProperties["maxWidth"];
}

/**
 * Reusable estimate section: a black title bar followed by padded content.
 * Used for DESCRIPTION/AMOUNT, INCLUSIONS, CUSTOMIZATION, ASSUMPTIONS, TERMS.
 */
const QuoteSection: React.FC<QuoteSectionProps> = ({
  title,
  rightTitle,
  children,
  maxWidth,
}) => {
  const theme = useTheme();

  const barStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    background: theme.palette.common.black,
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  };

  const barTextStyle: React.CSSProperties = {
    color: theme.palette.common.white,
    fontSize: "1em",
  };

  const bodyStyle: React.CSSProperties = {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  };

  return (
    <div style={{ width: "100%", maxWidth }}>
      <div style={barStyle}>
        <div style={{ flexGrow: 1 }}>
          <Typography variant="body1" style={barTextStyle}>
            {title}
          </Typography>
        </div>

        {rightTitle ? (
          <Typography variant="body1" style={barTextStyle}>
            {rightTitle}
          </Typography>
        ) : null}
      </div>

      <div style={bodyStyle}>{children}</div>
    </div>
  );
};

export default QuoteSection;
